module.exports = __webpack_public_path__ + "img/money-bag-icon.dbb3f80.svg";